/**
 * Política de senha do Salvia — espelho do backend.
 *
 * A regra de verdade é a do Laravel (AppServiceProvider::definePasswordPolicy):
 * min(10)->mixedCase()->numbers()->symbols()->uncompromised(). Esta lista só
 * existe para a tela explicar ANTES de enviar o que falta. As expressões são
 * as mesmas que o Laravel usa (Rules\Password), para tela e servidor nunca
 * discordarem sobre uma senha.
 *
 * O item "vazamentos" não dá para conferir aqui: é o servidor que consulta a
 * base do Have I Been Pwned ao salvar. Ele aparece na lista como aviso.
 */
export const TAMANHO_MINIMO = 10;

export const REQUISITOS_DE_SENHA = [
  {
    id: "tamanho",
    texto: `Pelo menos ${TAMANHO_MINIMO} caracteres`,
    atende: (s) => [...s].length >= TAMANHO_MINIMO,
  },
  {
    id: "maiusculaMinuscula",
    texto: "Letras maiúsculas e minúsculas",
    atende: (s) => /(\p{Ll}+.*\p{Lu})|(\p{Lu}+.*\p{Ll})/u.test(s),
  },
  {
    id: "numero",
    texto: "Pelo menos um número",
    atende: (s) => /\p{N}/u.test(s),
  },
  {
    id: "simbolo",
    texto: "Pelo menos um símbolo (ex.: ! @ # $ %)",
    atende: (s) => /\p{Z}|\p{S}|\p{P}/u.test(s),
  },
];

/** Os requisitos com o estado de cada um para esta senha. */
export function avaliarSenha(senha) {
  const s = String(senha || "");
  return REQUISITOS_DE_SENHA.map((r) => ({ ...r, ok: r.atende(s) }));
}

export function senhaAtendePolitica(senha) {
  return avaliarSenha(senha).every((r) => r.ok);
}

/** Regra pronta para o `:rules` dos v-text-field do Vuetify. */
export function regraDeSenhaForte(senha) {
  if (!senha) return "Senha é obrigatória";
  const falta = avaliarSenha(senha).find((r) => !r.ok);
  return falta ? `Falta: ${falta.texto.toLowerCase()}` : true;
}
